<template>
    <div class="card">
        <div class="card-header bg-white">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="text-5 font-weight-400 mb-3">Edit Profile Details</h3>
            </div>
        </div>
        <div class="card-body">
            <div v-if="message" class="bg-primary-dark text-white text-center p-2">
                {{ message }}
            </div>
            <div class="col-lg-6">
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Name</p>
                    <div class="col-12">
                        <input type="text" v-model="form.name" value="" :class="[ 'form-control' , form.errors.get('name') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('name')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Last Name</p>
                    <div class="col-12">
                        <input type="text" v-model="form.last_name" value="" :class="[ 'form-control' , form.errors.get('last_name') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('last_name')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Phone</p>
                    <div class="col-12">
                        <input type="text" v-model="form.phone" value="" :class="[ 'form-control' , form.errors.get('phone') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('phone')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Email</p>
                    <div class="col-12">
                        <input type="text" v-model="form.email" value="" :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white">
            <button @click="update" :class="['btn btn-primary' ,  form.loading ? 'btn-loading' : '']">Update
                Profile
            </button>
        </div>
    </div>

</template>

<script>
    import Form from "../../core/forms/form";

    export default {
        name: "profile",
        methods : {
            init()
            {
                this.loading = true;
                window.axios.get(`${window.location.origin}/admin/auth`).then((response) => {
                    this.model = response.data.body.model;
                    this.form.extract(this.model);
                }).finally(() => {
                    this.loading = false;
                });
            },

            update(){
                this.form.submit(`/admin/auth/update`).then((response) => {
                    this.message = "Your profile was successfully updated";
                }).catch((error) => {
                }).finally(() => {
                });
            }
        },
        mounted() {
            this.init();
        },
        data()
        {
            return {
                model : {},
                message : null,
                form :  new Form({
                    name : '',
                    last_name : '',
                    email : '',
                    phone : '',
                })
            };
        }

    }
</script>

<style scoped>

</style>
